import { useEffect, useState } from 'react';
import { useDatabase } from './useDatabase';

export interface ResourceGroupDetails {
  id: string;
  name: string;
  managedByTeamId: string | undefined;
}

export function useResourceGroup(groupId: string | undefined) {
  const { database, loading: databaseLoading } = useDatabase();
  const [group, setGroup] = useState<ResourceGroupDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!database || !groupId) {
      if (!database) setLoading(false);
      return;
    }

    try {
      const groups = database.resource_groups();
      const obj = groups[groupId];

      if (!obj) {
        setError(`Resource group with ID ${groupId} not found`);
        setGroup(null);
      } else {
        setGroup({
          id: groupId,
          name: obj.name(),
          managedByTeamId: obj.managed_by_team_id() ?? undefined,
        });
        setError(null);
      }
    } catch (err) {
      console.error('Error fetching resource group:', err);
      setError(`Error fetching resource group: ${err}`);
      setGroup(null);
    } finally {
      setLoading(false);
    }
  }, [database, groupId]);

  return { group, loading: loading || databaseLoading, error };
}
